import React, { useEffect, useState } from "react";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Stack,
  HStack,
  Heading,
  useToast,
  Button,
  IconButton,
  Tooltip,
  CircularProgress,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import EliminarSander from "./components/sanders/EliminarSander";
import { getSander } from "../operaciones/helpers/api.helper";
import { MdAddCircleOutline, MdOutlineCreate } from "react-icons/md";
import { useSelector } from "react-redux";

const Sander = () => {
  const [sanders, setSanders] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const toast = useToast();
  const { user } = useSelector((state) => state.user);

  const initData = async () => {
    setLoading(true);

    let res = await getSander();
    if (res.status === 200) {
      setSanders(res.data);
    } else {
      toast({
        title: "Error",
        description: "Error al cargar los sanders",
        duration: 3000,
        isClosable: true,
        status: "error",
      });
    }

    setLoading(false);
  };

  const loadingtable = () => {
    return (
      <HStack w="100%" placeContent="center">
        <CircularProgress isIndeterminate color="brand.naranja" />
      </HStack>
    );
  };

  useEffect(() => {
    initData();
  }, []);

  return (
    <Stack w="100%" h="xl">
      <HStack w="100%" justifyContent="space-between" px={5}>
        <Heading
          fontWeight="medium"
          size="xl"
          fontFamily="fonts.title"
          color="brand.gris_primario"
        >
          Sanders
        </Heading>
        {(user.idRol === "admin" ||
          user.idRol === "coorOp" ||
          user.idRol === "usuarioIT") && (
          <Button
            size="sm"
            variant="outline"
            border="1px solid #FF8200"
            leftIcon={<MdAddCircleOutline fontSize="20px" />}
            color="brand.naranja"
            onClick={() => navigate("/inventario/sander/nuevo")}
            _hover={{ bg: "brand.naranja", color: "white" }}
          >
            Nuevo sander
          </Button>
        )}
      </HStack>
      {loading && loadingtable()}
      {!loading && sanders.length > 0 && (
        <TableContainer>
          <Table size="sm" h="max-content" variant="simple">
            <Thead>
              <Tr borderBottom="2px solid black">
                <Th>ID Sander</Th>
                <Th>SET</Th>
                <Th>Status</Th>
                <Th>Power Pack</Th>
                {(user.idRol === "admin" ||
                  user.idRol === "coorOp" ||
                  user.idRol === "usuarioIT") && (
                  <Th textAlign={"center"}>Acciones</Th>
                )}
              </Tr>
            </Thead>
            <Tbody>
              {sanders.map((sander) => (
                <Tr key={sander.idSander}>
                  <Td>{sander.codigoSander}</Td>
                  <Td>
                    {sander.idSET === "set1"
                      ? "SET 1"
                      : sander.idSET === "set2"
                      ? "SET 2"
                      : "-"}
                  </Td>
                  <Td
                    color={sander.estadoSander === "activo" ? "green" : "red"}
                  >
                    {sander.estadoSander === "activo" ? "Activo" : "Inactivo"}
                  </Td>
                  <Td>{sander.powerPack}</Td>
                  {(user.idRol === "admin" ||
                    user.idRol === "coorOp" ||
                    user.idRol === "usuarioIT") && (
                    <Td textAlign={"center"}>
                      <Tooltip label="Editar Sander">
                        <IconButton
                          variant="link"
                          icon={<MdOutlineCreate fontSize="20px" />}
                          isDisabled={user.idRol === "usuarioIT"}
                          onClick={() =>
                            navigate(
                              `/inventario/sander/editar/${sander.idSander}`
                            )
                          }
                          _hover={{ color: "brand.naranja" }}
                        />
                      </Tooltip>
                      <EliminarSander
                        sander={sander}
                        initData={initData}
                        user={user}
                      />
                    </Td>
                  )}
                </Tr>
              ))}
            </Tbody>
          </Table>
        </TableContainer>
      )}
      {!loading && sanders.length < 1 && (
        <Heading textAlign={"center"} size={"md"}>
          No hay datos para mostrar
        </Heading>
      )}
    </Stack>
  );
};

export default Sander;
